module.exports = __webpack_public_path__ + "img/Group 936.f89c1ae9.png";